module.exports = __webpack_public_path__ + "static/img/tel_icon.dd0d5d37.png";